export default "__VITE_ASSET__CH0p4fK2__"